
<template>
  <div class="knd-eindscherm">
    <div class="knd-paragraaf">
     <h2>Jouw Score</h2>

     <div class="m-b-xl">
      Je hebt {{ $store.getters.totalAnswers }} van de {{ $store.getters.answers.length }} vragen beantwoord.
     </div>

    <div class="" v-if="$store.getters.totalAnswers > 0">
      <div class="knd-percentage">
        <div class="knd-percentage-value">{{ score }}</div>
        <div class="knd-percentage-symbol">%</div>
      </div>

      <div class="knd-feedback m-b-xl">
        <span>{{scoreFeedback.titel}}</span>
      </div>
      
      <div class="m-b-xxl" v-html="scoreFeedback.tekst"></div>
    </div>

    <div class="feedback-click-hint m-b-xxl">
      <div class="feedback-click-hint-icon">
        <ProgressionBox 
          :answer="{answered: true, correct: false}"
          :size="30"
        />
      </div>
      <div>
        Check alle factchecks per vraag door te klikken op de kiesvakjes iconen hierboven. (vooral de vragen die je fout had)
      </div>
    </div>

    <div class="feedback-stickers m-b-xl "  @click="clickDownload" v-if="data.url">
      <div class="feedback-stickers-title" v-html="data.stickertekst"></div>
      <div class="feedback-stickers-image hover-animation">
        <div v-if="data.media.afbeelding && data.media.afbeelding.length > 0">
          <ImagePart :media="data.media.afbeelding" :size="data.media.size"/>
        </div>

      </div>
      <div class="knd-btn-container  m-b-xl" >
        <img class="confetti" :class="{show: showConfetti}" src="@/assets/images/confetti.png" />
      </div>

    </div>
    
    
    <div v-html="data.tekst"></div>
    </div>
  </div>
</template>

<script>
import { ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import ImagePart from '@/components/image';

import ProgressionBox from '@/components/progression/box';

export default {
  props: {
    data:{
      type: Object
    },
    answers: {
      type: Array
    }
  },
  components: {ProgressionBox, ImagePart},
  setup(props) {
    const count = ref(0)
		const store = useStore();
    const showConfetti = ref(false);
    
    function getVideo(name) {
      return require('@/assets/video/' + name);
    }

    let score = ref(0);
    let scoreFeedback = ref(undefined);
    calculatePercentage();

    watch(() => store.getters.totalCorrect, function() {
      calculatePercentage();
   });

   watch(() => store.getters.totalFalse, function() {
      calculatePercentage();
   });

    function calculatePercentage() {
      let totalCorrect = store.getters.totalCorrect;
      let totalFalse =  store.getters.totalFalse;
      score.value = Math.floor((totalCorrect / (totalCorrect + totalFalse)) * 100) || 0;

      let feedbackIndex = 0;

      props.data.opties.map((item, index) => {
        if(score.value >= item.percentage) {
          feedbackIndex = index;
        }
      });
      scoreFeedback.value = props.data.opties[feedbackIndex];
    }

    function clickDownload() {
      showConfetti.value = true;
      if(!props.data.url) return;
      
      window.open(props.data.url, '_blank').focus();
    }

    // expose to template and other options API hooks
    return {
      showConfetti,
      count,
      getVideo,
      VUE_APP_PBASE: process.env.VUE_APP_PBASE,
      score,
      scoreFeedback,
      clickDownload,
      totalCorrect: computed(() => store.getters.totalCorrect),
      totalFalse: computed(() => store.getters.totalFalse)
    }
  }
}
</script>

<style lang="scss">
  .knd-eindscherm {
    background: linear-gradient(192.17deg, #28006D 37.82%, #00DEB2 96.84%);
    color: #FFF;
  }

  .knd-percentage {
    display:flex;
    justify-content: center;
    .knd-percentage-value {
      font-size: 120px;
      font-weight: bold;
      font-family: $font-header;
    }

    .knd-percentage-symbol {
      font-weight: 200;
      font-size: 2em;
    }
  }

  .knd-feedback {
    margin: 0 auto;
    max-width: 80%;
    text-align: center;
    
    span {
      display: inline-block;
      background: #00D9AD;
      padding: 1em;
      border-radius: 10px;

    }
  }

  .feedback-stickers {
    cursor: pointer;
  }

  .feedback-click-hint {
    display: flex;

    .feedback-click-hint-icon {
      margin-right: 2rem;
    }
  }

  .download-btn {
    margin-top: -50px;
    .knd-btn{
      background: #00D9AD;
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  .confetti {
    opacity: 0;
    // transform: scale(0);
    position: fixed;
    top: 50%;
    left:50%;
    transform: translate(-50%, -50%) scale(0);
    transform-origin: center center;
    pointer-events: none;

    // transition: transform .5s ease-in;

    &.show {
      opacity: 1;
      animation-duration: 1.5s;
      animation-timing-function: ease-in-out;
      animation-name: confetti;
      // animation-iteration-count: infinite;
    }
  }

  @keyframes confetti {
  from {
    transform: translate(-50%, -50%) scale(0);
  }

  75% {
    transform: translate(-50%, -50%) scale(2);
  }

  to {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
  }
}

@keyframes confetti2 {
  from {
    transform: translate(-50%, -120%) scale(1);
  }

  75% {
    // transform: translate(-50%, -50%) scale(1);
  }

  to {
    transform: translate(-50%, 100%) scale(1);
    opacity: 0;
  }
}

</style>